module.exports = __webpack_public_path__ + "static/daft-apeth-industries-d8e880c491e5dc6c188ac934d02e51b8.png";